<template>
    <div class="thank-page">
        <img :src="stadaLogo" class="logo"/>
        <form>
            <h2 class="login-title">
                Köszönjük, hogy kitöltötted a kérdőívet,
                <br/>
                az eredményről e-mailben fogunk tájékoztatni.
            </h2>
        <input type="submit" class="btn" @click="logout()" value="Befejez"/>
        </form>
    </div>
</template>

<script>
import stadaLogo from '@/assets/img/stada_logo_cmyk_color.png';

export default {
    data: () => {
        return {
            stadaLogo
        }
    },
    mounted() {
        this.$store.state.buttonDisabled = true;
        var sessionEndData = {
            'session_id': this.$store.state.session_id
        }
        this.axios.post('/backend/web/endsession?access-token=' + this.$store.state.privateKey, sessionEndData);
    },
    methods: {
        logout() {
            localStorage.removeItem('stada_private_key');
            this.$store.state.privateKey="";
            this.$router.push({path: "/"});
        }
    }
}

   
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '~@/assets/sass/base/variables';
    .thank-page {
        .logo{
            width: 220px;
            height: 127.5px;
            object-fit: contain;
            margin-top: 150px;
            margin-bottom: 0px;
        }

        h2{
            font-size: 21px;
            color: #4a4a4a;
            margin-top: 61.5px;
            margin-bottom: 31px;
        }
    }

</style>
